import axios from "axios";
import { useEffect, useState } from "react";


export const useLocalization = () => {

    
    const [geolocationState, setGeolocationState] = useState<number>(0); // 0 Is not working, 1 We can't get the coordinates, // 2  It's okay
    const [latlng, setLatlng] = useState<[number, number]>([NaN, NaN]);



    useEffect(() => {
        validateGeolocation().then(bool => {
          getUserLocation().then(latlng => {
            setLatlng(latlng)
            setGeolocationState(2);
          })
        })
    
      }, [navigator.geolocation])

    const validateGeolocation = async (): Promise<boolean> => {
        return new Promise((resolve, reject) => {
          if (navigator.geolocation) {
            resolve(true);
          } else {
            setGeolocationState(0);
            reject();
          }
        });
      }
    
      const getUserLocation = async (): Promise<[number, number]> => {
        return new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            ({ coords }) => {
              resolve([coords.latitude, coords.longitude]);
            },
            (err) => {
              setGeolocationState(1);
              console.error(err);
              reject();
            }
          )
    
        });
      }

      
      function distanceBetweenPoints(lat1: number, lon1: number, lat2: number, lon2: number): number {
        const earthRadius: number = 6371000; // Earth's radius in meters
        const dLat: number = toRadians(lat2 - lat1);
        const dLon: number = toRadians(lon2 - lon1);
        const a: number = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
          Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c: number = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance: number = earthRadius * c;
        return distance;
      }
    
      function toRadians(degrees: number): number {
        return degrees * (Math.PI / 180);
      }
    
      function checkDistance(lat1: number, lon1: number, lat2: number, lon2: number): boolean {
        const distance: number = distanceBetweenPoints(lat1, lon1, lat2, lon2);
        return distance <= 200;
      }
    
   

    return {
        geolocationState,
        setGeolocationState,
        validateGeolocation,
        getUserLocation,
        checkDistance,
        latlng,
        setLatlng
    }
}